import React from 'react';

class Home extends React.Component{
    render(){
        return(
        <div>
            
            <div class="banner-ai">
    <div class="container position-relative">
        <div class="banner-ai-inner">
        <div class="banner-ai-links">
            <ul>
                <li><a href="#">Home</a></li>
                <li><a href="#">Data Science</a></li>
                <li><a href="#">Executive PG Programme In Data Science</a></li>
            </ul>
        </div>
        <div class="bestsaller">
            <span><i class="fa fa-star" aria-hidden="true"></i> Bestseller</span>
        </div>
        <div class="banner-ai-text">
            <h1>Executive Post Graduate Programme in Data Science</h1>
            <p>Begin your journey with India’s #1 online Data Science Program. This program is equivalent to a 1 year Postgraduate Diploma in Canada. Eligibility: Bachelor’s degree with 50% mandatory.</p>
        </div>
        <div class="banner-ai-btngrp">
            <a href="#" class="applybtn">Apply Now</a>
            <a href="#" class="downbtn"><i class="fa fa-download" aria-hidden="true"></i> Download Syllabus</a>
            <div class="watchbanner">
                <div class="rippleinfo" data-toggle="modal" data-target="#introvideo">                
                    <span><i class="fa fa-play videoicons" aria-hidden="true"></i></span>
                  </div>
                  <h6>Watch <br/><label>INTRO VIDEO</label></h6>
                </div>
        </div>
        <div class="banner-ai-experts">
            <p>With Industry Experts From</p>
            <a href="#"><img src="assets/images/gramener.png" alt="" /></a>
            <a href="#"><img src="assets/images/actify.png" alt="" /></a>
            <a href="#"><img src="assets/images/flipcart.png" alt="" /></a>
            <a href="#"><img src="assets/images/walmart.png" alt="" /></a>
            <a href="#"><img src="assets/images/zee.png" alt="" /></a>
        </div>
    </div>
    </div>
</div>


<div class="banner-aistrip">
    <div class="container">
        <ul>
            <li>
                <span><img src="assets/images/banner-aistrip-icon1.png" alt="" /></span>
                <div class="banner-aistrip-text">
                     <h5>India's #1 Technical University (Private)</h5>
                     <p>Source - India Today, 2021</p>
                </div>
            </li>
            <li>
                <span><img src="assets/images/banner-aistrip-icon2.png" alt="" /></span>
                <div class="banner-aistrip-text">
                     <h5>Blended</h5>
                     <p>Format</p>
                </div>
            </li>
            <li>
                <span><img src="assets/images/banner-aistrip-icon3.png" alt="" /></span>
                <div class="banner-aistrip-text">
                     <h5>12 months</h5>
                     <p>Recommended 12-15 hrs/week</p>
                </div>
            </li>
            <li>
                <span><img src="assets/images/banner-aistrip-icon4.png" alt="" /></span>
                <div class="banner-aistrip-text">
                     <h5>Jan 31, 2023</h5>
                     <p>Start Date</p>
                </div>
            </li>
            <li>
                <span><img src="assets/images/banner-aistrip-icon5.png" alt="" /></span>
                <div class="banner-aistrip-text">
                     <h5>Starts at INR 6,736/month*</h5>
                     <p>EMI Options Available</p>
                </div>
            </li>
        </ul>
    </div>
</div>


<div class="itfeaturevideorow">
    <div class="container">
        <h1>Why AI and data science is the feature of IT</h1>
        <div class="itfeaturevideo">
        <iframe loading="lazy" width="100%" height="450" src="https://www.youtube.com/embed/F9Lf-mejfdA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
        </div>
    </div>
</div>


<div class="careeroppbg">
    <div class="container">
        <div class="careeroppbg-inner">
            <h1>Career Opportunities</h1>

  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#tab01"><span><img src="assets/images/opportunities-icon1.png" alt="" /></span>Machine Learning Engineer</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#tab02"><span><img src="assets/images/opportunities-icon2.png" alt="" /></span>Data Scientist</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#tab03"><span><img src="assets/images/opportunities-icon3.png" alt="" /></span>Business Intelligence Developer</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#tab04"><span><img src="assets/images/opportunities-icon4.png" alt="" /></span>Software Engineer</a>
      </li>
  </ul>

  <div class="tab-content">
    <div id="tab01" class="tab-pane active">
      <div class="careeroppbg-inner-text">
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniamquis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.</p>
        <h3>Average Salaries</h3>
        <h3>Rs. 400K - Rs. 2000K <span>Per annum</span></h3>
        <h4>Hiring Compenies</h4>
        <a href="#"><img src="assets/images/microsofticon.png" alt="" /></a>
        <a href="#"><img src="assets/images/walmarticon.png" alt="" /></a>
        <a href="#"><img src="assets/images/googleicon.png" alt="" /></a>
        <a href="#"><img src="assets/images/amazonicon.png" alt="" /></a>
        <a href="#"><img src="assets/images/flipcarticon.png" alt="" /></a>
      </div>
    </div>
    <div id="tab02" class="tab-pane fade">
        <div class="careeroppbg-inner-text">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniamquis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.</p>
            <h3>Average Salaries</h3>
            <h3>Rs. 400K - Rs. 2000K <span>Per annum</span></h3>
            <h4>Hiring Compenies</h4>
            <a href="#"><img src="assets/images/microsofticon.png" alt="" /></a>
            <a href="#"><img src="assets/images/walmarticon.png" alt="" /></a>
            <a href="#"><img src="assets/images/googleicon.png" alt="" /></a>
            <a href="#"><img src="assets/images/amazonicon.png" alt="" /></a>
            <a href="#"><img src="assets/images/flipcarticon.png" alt="" /></a>
          </div>
    </div>
    <div id="tab03" class="tab-pane fade">
        <div class="careeroppbg-inner-text">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniamquis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.</p>
            <h3>Average Salaries</h3>
            <h3>Rs. 400K - Rs. 2000K <span>Per annum</span></h3>
            <h4>Hiring Compenies</h4>
            <a href="#"><img src="assets/images/microsofticon.png" alt="" /></a>
            <a href="#"><img src="assets/images/walmarticon.png" alt="" /></a>
            <a href="#"><img src="assets/images/googleicon.png" alt="" /></a>
            <a href="#"><img src="assets/images/amazonicon.png" alt="" /></a>
            <a href="#"><img src="assets/images/flipcarticon.png" alt="" /></a>
          </div>
    </div>
    <div id="tab04" class="tab-pane fade">
        <div class="careeroppbg-inner-text">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniamquis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.</p>
            <h3>Average Salaries</h3>
            <h3>Rs. 400K - Rs. 2000K <span>Per annum</span></h3>
            <h4>Hiring Compenies</h4>
            <a href="#"><img src="assets/images/microsofticon.png" alt="" /></a>
            <a href="#"><img src="assets/images/walmarticon.png" alt="" /></a>
            <a href="#"><img src="assets/images/googleicon.png" alt="" /></a>
            <a href="#"><img src="assets/images/amazonicon.png" alt="" /></a>
            <a href="#"><img src="assets/images/flipcarticon.png" alt="" /></a>
          </div>
      </div>
  </div>

        </div>
    </div>
</div>


<div class="getcertfiedbgnew">
    <div class="container">
        <div class="getcertfiedbgnew-inner">
            <h1>Get Certified & Move Towards Your Dream Job</h1>
            <h6>Our Domain Specialisation and Industry Certified Capstone Projects helps you to make your past work experience relevant</h6>
            <div class="row">
                <div class="col-md-4">
                    <div class="getcertfiedbgnew-box">
                        <i class="fa fa-laptop" aria-hidden="true"></i>
                        <h2>100% Live Online Classes</h2>
                        <p>Faculty led Live Interactive online classes. Ask doubts in live classroom</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="getcertfiedbgnew-box">
                        <i class="fa fa-file-text-o" aria-hidden="true"></i>
                        <h2>IBM Certified Capstone</h2>
                        <p>Faculty led Live Interactive online classes. Ask doubts in live classroom</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="getcertfiedbgnew-box">
                        <i class="fa fa-briefcase" aria-hidden="true"></i>
                        <h2>Guaranteed Job Referr</h2>
                        <p>Faculty led Live Interactive online classes. Ask doubts in live classroom</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="ourclientbg-new">
    <div class="container">
        <h1>Our Alumni Works at</h1>
        <div class="owl-carousel owl-theme">
            <div class="item">
                <img src="assets/images/microsofticon.png" alt="" />
                <img src="assets/images/walmarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div class="item">
                <img src="assets/images/amazonicon.png" alt="" />
                <img src="assets/images/flipcarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div class="item">
                <img src="assets/images/microsofticon.png" alt="" />
                <img src="assets/images/walmarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div class="item">
                <img src="assets/images/amazonicon.png" alt="" />
                <img src="assets/images/flipcarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div class="item">
                <img src="assets/images/microsofticon.png" alt="" />
                <img src="assets/images/walmarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div class="item">
                <img src="assets/images/amazonicon.png" alt="" />
                <img src="assets/images/flipcarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
        </div>
    </div>
</div>


<div class="whymakesnew">
    <div class="container">
        <h1>What Makes Us Unique?</h1>
        <div class="row">
            <div class="col-md-4">
                <div class="whymakes-box">
                    <img src="assets/images/whymake-icon1.png" alt="" />
                    <h4>60+ Case Studies & Assignments</h4>
                    <p>Work on 60+ Case studies ad assignments with 24/7 Assignments suport.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="whymakes-box">
                    <img src="assets/images/whymake-icon2.png" alt="" />
                    <h4>18+ Industry Relevant Projects</h4>
                    <p>Work on 60+ Case studies ad assignments with 24/7 Assignments suport.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="whymakes-box">
                    <img src="assets/images/whymake-icon3.png" alt="" />
                    <h4>Tied-up with 150+ Companies</h4>
                    <p>Work on 60+ Case studies ad assignments with 24/7 Assignments suport.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="whymakes-box">
                    <img src="assets/images/whymake-icon1.png" alt="" />
                    <h4>60+ Case Studies & Assignments</h4>
                    <p>Work on 60+ Case studies ad assignments with 24/7 Assignments suport.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="whymakes-box">
                    <img src="assets/images/whymake-icon2.png" alt="" />
                    <h4>18+ Industry Relevant Projects</h4>
                    <p>Work on 60+ Case studies ad assignments with 24/7 Assignments suport.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="whymakes-box">
                    <img src="assets/images/whymake-icon3.png" alt="" />
                    <h4>Tied-up with 150+ Companies</h4>
                    <p>Work on 60+ Case studies ad assignments with 24/7 Assignments suport.</p>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="artificialintelligence-bg">
    <div class="container">
        <h1>There are some myth about the Artificial Intelligence and Machine Learning</h1>
        <div class="row">
            <div class="col-lg-6">
                <div class="artificialintelligence">
                    <div class="artificialintelligence-topimg"><img src="assets/images/dislike.png" alt="" /></div>
                    <ul>
                        <li>
                            <span><img src="assets/images/wrong.png" alt="" /></span> Focus should not be on earning certifications from MNC
                        </li>
                        <li>
                            <span><img src="assets/images/wrong.png" alt="" /></span> Focus should not be on earning from MNC Focus should not be on earning certifications from MNC
                        </li>
                        <li>
                            <span><img src="assets/images/wrong.png" alt="" /></span> Focus should not be on earning certifications from MNC Focus
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="artificialintelligence">
                    <div class="artificialintelligence-topimg"><img src="assets/images/like.png" alt="" /></div>
                    <ul>
                        <li>
                            <span><img src="assets/images/right.png" alt="" /></span> Focus should not be on earning certifications from MNC
                        </li>
                        <li>
                            <span><img src="assets/images/right.png" alt="" /></span> Focus should not be on earning from MNC Focus should not be on earning certifications from MNC
                        </li>
                        <li>
                            <span><img src="assets/images/right.png" alt="" /></span> Focus should not be on earning certifications from MNC Focus
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="specialisation-bg">
    <div class="container">
        <h1>Specialisation</h1>
        <h5>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</h5>

  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#tab06">Machine Learning Engineer</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#tab07">Data Scientist</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#tab08">Business Intelligence Developer</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#tab09">Software Engineer</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#tab010">Software Engineer</a>
      </li>
  </ul>

  <div class="tab-content">
    <div id="tab06" class="tab-pane active">
        <div class="topic_covered">
            <h2>Topics Covered</h2>
            <div class="row">
                <div class="col-md-6">
                    <div class="coveredrow">
                        <div class="coveredrow-left"><span>1</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox2">
                        <div class="coveredrow-left"><span>2</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox3">
                        <div class="coveredrow-left"><span>3</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox4">
                        <div class="coveredrow-left"><span>4</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox5">
                        <div class="coveredrow-left"><span>5</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox6">
                        <div class="coveredrow-left"><span>6</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox7">
                        <div class="coveredrow-left"><span>7</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox8">
                        <div class="coveredrow-left"><span>8</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox9">
                        <div class="coveredrow-left"><span>9</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox10">
                        <div class="coveredrow-left"><span>10</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox11">
                        <div class="coveredrow-left"><span>11</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox12">
                        <div class="coveredrow-left"><span>12</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="tab07" class="tab-pane fade">
        <div class="topic_covered">
            <h2>Topics Covered</h2>
            <div class="row">
                <div class="col-md-6">
                    <div class="coveredrow">
                        <div class="coveredrow-left"><span>1</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox2">
                        <div class="coveredrow-left"><span>2</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox3">
                        <div class="coveredrow-left"><span>3</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox4">
                        <div class="coveredrow-left"><span>4</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox5">
                        <div class="coveredrow-left"><span>5</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox6">
                        <div class="coveredrow-left"><span>6</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox7">
                        <div class="coveredrow-left"><span>7</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox8">
                        <div class="coveredrow-left"><span>8</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox9">
                        <div class="coveredrow-left"><span>9</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox10">
                        <div class="coveredrow-left"><span>10</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox11">
                        <div class="coveredrow-left"><span>11</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox12">
                        <div class="coveredrow-left"><span>12</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="tab08" class="tab-pane fade">
        <div class="topic_covered">
            <h2>Topics Covered</h2>
            <div class="row">
                <div class="col-md-6">
                    <div class="coveredrow">
                        <div class="coveredrow-left"><span>1</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox2">
                        <div class="coveredrow-left"><span>2</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox3">
                        <div class="coveredrow-left"><span>3</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox4">
                        <div class="coveredrow-left"><span>4</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox5">
                        <div class="coveredrow-left"><span>5</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox6">
                        <div class="coveredrow-left"><span>6</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox7">
                        <div class="coveredrow-left"><span>7</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox8">
                        <div class="coveredrow-left"><span>8</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox9">
                        <div class="coveredrow-left"><span>9</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox10">
                        <div class="coveredrow-left"><span>10</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox11">
                        <div class="coveredrow-left"><span>11</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox12">
                        <div class="coveredrow-left"><span>12</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="tab09" class="tab-pane fade">
        <div class="topic_covered">
            <h2>Topics Covered</h2>
            <div class="row">
                <div class="col-md-6">
                    <div class="coveredrow">
                        <div class="coveredrow-left"><span>1</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox2">
                        <div class="coveredrow-left"><span>2</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox3">
                        <div class="coveredrow-left"><span>3</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox4">
                        <div class="coveredrow-left"><span>4</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox5">
                        <div class="coveredrow-left"><span>5</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox6">
                        <div class="coveredrow-left"><span>6</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox7">
                        <div class="coveredrow-left"><span>7</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox8">
                        <div class="coveredrow-left"><span>8</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox9">
                        <div class="coveredrow-left"><span>9</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox10">
                        <div class="coveredrow-left"><span>10</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox11">
                        <div class="coveredrow-left"><span>11</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox12">
                        <div class="coveredrow-left"><span>12</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div id="tab010" class="tab-pane fade">
        <div class="topic_covered">
            <h2>Topics Covered</h2>
            <div class="row">
                <div class="col-md-6">
                    <div class="coveredrow">
                        <div class="coveredrow-left"><span>1</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox2">
                        <div class="coveredrow-left"><span>2</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox3">
                        <div class="coveredrow-left"><span>3</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox4">
                        <div class="coveredrow-left"><span>4</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox5">
                        <div class="coveredrow-left"><span>5</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox6">
                        <div class="coveredrow-left"><span>6</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox7">
                        <div class="coveredrow-left"><span>7</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox8">
                        <div class="coveredrow-left"><span>8</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox9">
                        <div class="coveredrow-left"><span>9</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox10">
                        <div class="coveredrow-left"><span>10</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox11">
                        <div class="coveredrow-left"><span>11</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="coveredrow colorbox12">
                        <div class="coveredrow-left"><span>12</span></div>
                        <div class="coveredrow-right">
                            <h3>Model Selection <br/>& General ML Techniques</h3>
                            <p>Post Course 2 (Machine Learning), choose any one of the below 5 specialisations as per your background and career aspirations</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
  </div>

    </div>
</div>


<div class="projectsnewbg">
    <div class="container">
        <h1>Projects</h1>
        <h5>Projects will be a part of your Certification in Data Science & Artificial Intelligence to consolidate your learning. <br/>
            It will ensure that you have real-world experience in Data Science and AI.</h5>
         <div class="projectsnewbg-practice">
            <ul>
                <li>
                    <img src="assets/images/practice-icon.png" alt="" />
                    <h3>Practice 20+</h3>
                    <p>Essential Tools</p>
                </li>
                <li>
                    <img src="assets/images/designed-icon.png" alt="" />
                    <h3 style={{color: '#2aacf6'}}>Designed by</h3>
                    <p>Industry Experts</p>
                </li>
                <li>
                    <img src="assets/images/get-icon.png" alt="" />
                    <h3 style={{color: '#1fcd71'}}>Get Real-world</h3>
                    <p>Experience</p>
                </li>
            </ul>
         </div>

         <div class="projectsnewbg-bottom">

            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" data-toggle="tab" href="#tab012">Beginner</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#tab013">Intermediate</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#tab014">Advance</a>
                </li>
             </ul>
            
              <div class="tab-content">
                <div id="tab012" class="tab-pane active">
                    <div id="products" class="owl-carousel owl-theme">
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Face Detection</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>AI Chatbot</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>Restaurant Revenue Prediction</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Face Detection</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>AI Chatbot</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>Restaurant Revenue Prediction</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                    </div>
                </div>
              
                <div id="tab013" class="tab-pane fade">
                    <div id="products1" class="owl-carousel owl-theme">
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Face Detection</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>AI Chatbot</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>Restaurant Revenue Prediction</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Face Detection</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>AI Chatbot</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>Restaurant Revenue Prediction</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="tab014" class="tab-pane fade">
                    <div id="products2" class="owl-carousel owl-theme">
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Face Detection</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>AI Chatbot</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>Restaurant Revenue Prediction</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Face Detection</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>AI Chatbot</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>Restaurant Revenue Prediction</span></h3>
                                <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>

         </div>

    </div>
</div>


<div class="syllabusnewbg">
    <div class="container">
        <div class="row">
        <div class="col-lg-7">

            <div class="syllabusheadings">
                <h1>
                    <span>Syllabus</span>
                    <a href="#"><i class="fa fa-download" aria-hidden="true"></i>  Download brochure</a>
                </h1>
                <p>Data Structure and Algorithm course curated by leading faculties and industry leaders to provide pratical learning experience with live interactive classes and projects.
                </p>
            </div>

            <div class="faqnew">
                <div class="accordion" id="accordionExample">

                    <div class="card">

                        <div class="card-header" id="heading00">
                  
                          <h2 class="mb-0">
                  
                            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse00" aria-expanded="false"><i class="fa fa-angle-down"></i> Module 0 Introduction </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse00" class="collapse" aria-labelledby="heading00" data-parent="#accordionExample">
                  
                          <div class="card-body">
                  
                            <div class="moduleintro">
                                <h4>Chapter 1: A primer on Machine Learning ( 3 hrs )</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 class="mt-3">Chapter 2: Regression</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div class="card">

                        <div class="card-header" id="heading001">
                  
                          <h2 class="mb-0">
                  
                            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse001" aria-expanded="false"><i class="fa fa-angle-down"></i> Module 1 - Programming Essentials </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse001" class="collapse" aria-labelledby="heading001" data-parent="#accordionExample">
                  
                          <div class="card-body">
                  
                            <div class="moduleintro">
                                <h4>Chapter 1: A primer on Machine Learning ( 3 hrs )</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 class="mt-3">Chapter 2: Regression</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div class="card">

                        <div class="card-header" id="heading002">
                  
                          <h2 class="mb-0">
                  
                            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse002" aria-expanded="false"><i class="fa fa-angle-down"></i> Module 2 - Applied Statistics </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse002" class="collapse" aria-labelledby="heading002" data-parent="#accordionExample">
                  
                          <div class="card-body">
                  
                            <div class="moduleintro">
                                <h4>Chapter 1: A primer on Machine Learning ( 3 hrs )</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 class="mt-3">Chapter 2: Regression</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div class="card">

                        <div class="card-header" id="heading003">
                  
                          <h2 class="mb-0">
                  
                            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse003" aria-expanded="false"><i class="fa fa-angle-down"></i> Module 3 - Advance Machine Learning </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse003" class="collapse" aria-labelledby="heading003" data-parent="#accordionExample">
                  
                          <div class="card-body">
                  
                            <div class="moduleintro">
                                <h4>Chapter 1: A primer on Machine Learning ( 3 hrs )</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 class="mt-3">Chapter 2: Regression</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div class="card">

                        <div class="card-header" id="heading004">
                  
                          <h2 class="mb-0">
                  
                            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse004" aria-expanded="false"><i class="fa fa-angle-down"></i> Module 4 - Deep Learning </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse004" class="collapse" aria-labelledby="heading004" data-parent="#accordionExample">
                  
                          <div class="card-body">
                  
                            <div class="moduleintro">
                                <h4>Chapter 1: A primer on Machine Learning ( 3 hrs )</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 class="mt-3">Chapter 2: Regression</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div class="card">

                        <div class="card-header" id="heading005">
                  
                          <h2 class="mb-0">
                  
                            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse005" aria-expanded="false"><i class="fa fa-angle-down"></i> Module 5 - NLP </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse005" class="collapse" aria-labelledby="heading005" data-parent="#accordionExample">
                  
                          <div class="card-body">
                  
                            <div class="moduleintro">
                                <h4>Chapter 1: A primer on Machine Learning ( 3 hrs )</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 class="mt-3">Chapter 2: Regression</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div class="card">

                        <div class="card-header" id="heading006">
                  
                          <h2 class="mb-0">
                  
                            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse006" aria-expanded="false"><i class="fa fa-angle-down"></i> Module 6- Reinforcement Learning (only in Pro Max) </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse006" class="collapse" aria-labelledby="heading006" data-parent="#accordionExample">
                  
                          <div class="card-body">
                  
                            <div class="moduleintro">
                                <h4>Chapter 1: A primer on Machine Learning ( 3 hrs )</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 class="mt-3">Chapter 2: Regression</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>
                    <div class="card">

                        <div class="card-header" id="heading007">
                  
                          <h2 class="mb-0">
                  
                            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse007" aria-expanded="false"><i class="fa fa-angle-down"></i> Module 7- Computer Vision (only in Pro Max) </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse007" class="collapse" aria-labelledby="heading007" data-parent="#accordionExample">
                  
                          <div class="card-body">
                  
                            <div class="moduleintro">
                                <h4>Chapter 1: A primer on Machine Learning ( 3 hrs )</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 class="mt-3">Chapter 2: Regression</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div class="card">

                        <div class="card-header" id="heading008">
                  
                          <h2 class="mb-0">
                  
                            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse008" aria-expanded="false"><i class="fa fa-angle-down"></i> Module 8 - Data Structures and Algorithms ( 12 Weeks ) (only in Pro Max) </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse008" class="collapse" aria-labelledby="heading008" data-parent="#accordionExample">
                  
                          <div class="card-body">
                  
                            <div class="moduleintro">
                                <h4>Chapter 1: A primer on Machine Learning ( 3 hrs )</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 class="mt-3">Chapter 2: Regression</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div class="card">

                        <div class="card-header" id="heading009">
                  
                          <h2 class="mb-0">
                  
                            <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse009" aria-expanded="false"><i class="fa fa-angle-down"></i> Module 9 - TOOLS </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse009" class="collapse" aria-labelledby="heading009" data-parent="#accordionExample">
                  
                          <div class="card-body">
                  
                            <div class="moduleintro">
                                <h4>Chapter 1: A primer on Machine Learning ( 3 hrs )</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 class="mt-3">Chapter 2: Regression</h4>
                                <ul>
                                    <li>Types of Learning - Supervised, Unsupervised and Reinforcement</li>
                                    <li>Statistics vs Machine Learning</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                </div>
            </div>
        </div>
        <div class="col-lg-5">
            <div class="programmright">

                <h1>Program highlights</h1>
            
                <div class="programlist">
            
                    <ul>
            
                        <li>
            
                            <div class="proginfoss">
            
                                <div class="priiconss"><img
                                        src="assets/images/highicon01.jpg" border="0"
                                        alt="" /></div>
            
                                <div class="protxts">110+ Hours Live sessions</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div class="proginfoss">
            
                                <div class="priiconss"><img
                                        src="assets/images/highicon02.jpg" border="0"
                                        alt="" /></div>
            
                                <div class="protxts">3+ Projects</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div class="proginfoss">
            
                                <div class="priiconss"><img
                                        src="assets/images/highicon03.jpg" border="0"
                                        alt="" /></div>
            
                                <div class="protxts">1:1 Doubt Session</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div class="proginfoss">
            
                                <div class="priiconss"><img
                                        src="assets/images/highicon04.jpg" border="0"
                                        alt="" /></div>
            
                                <div class="protxts">1 Year Subscription </div>
            
                            </div>
            
                        </li>
            
                    </ul>
            
                    <ul>
            
                        <li>
            
                            <div class="proginfoss">
            
                                <div class="priiconss"><img
                                        src="assets/images/highicon01.jpg" border="0"
                                        alt="" /></div>
            
                                <div class="protxts">Life time accessibility</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div class="proginfoss">
            
                                <div class="priiconss"><img
                                        src="assets/images/highicon02.jpg" border="0"
                                        alt="" /></div>
            
                                <div class="protxts">Job Assistance Program</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div class="proginfoss">
            
                                <div class="priiconss"><img
                                        src="assets/images/highicon03.jpg" border="0"
                                        alt="" /></div>
            
                                <div class="protxts">Peer to peer Learning</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div class="proginfoss">
            
                                <div class="priiconss"><img src="assets/images/highicon04.jpg" border="0"
                                        alt="" /></div>
            
                                <div class="protxts">Mock Interview </div>
            
                            </div>
            
                        </li>
            
                    </ul>
            
                </div>

                <p class="w-100 float-left">
                <a href="#" class="applnowbtn mt-4">Talk to our experts <i class="fa fa-angle-right arrowclass" aria-hidden="true"></i></a>
                </p>

            </div>
        </div>
    </div>
</div>
</div>



<div class="careerservices-new">
    <div class="container">
        <h1>Career Services By Logicmojo</h1>
        <div class="careerservices-new-left"><img src="assets/images/career-services.png" alt="" /></div>
        <div class="careerservices-new-right">
            <div class="projectsnewbg-bottom">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link active" data-toggle="tab" href="#tab020">Job Assistance</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-toggle="tab" href="#tab021">Interview Preparation</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-toggle="tab" href="#tab022">Profile Building</a>
                    </li>
                 </ul>
                 <div class="tab-content">
                    <div id="tab020" class="tab-pane active">
                        <div class="placement-assistance">
                            <div class="placement-assistance-left"><img src="assets/images/placement-assistance.png" alt="" /></div>
                            <div class="placement-assistance-right">
                                <h2>Placement Assistance</h2>
                                <p>Placement opportunities are provided once the learner is moved to the placement pool. Get noticed by our 400+ hiring partners.</p>
                                <a href="#"><i class="fa fa-calendar-o" aria-hidden="true"></i> After 100% of the course completion</a>
                            </div>
                        </div>
                        <div class="placement-assistance">
                            <div class="placement-assistance-left"><img src="assets/images/exclusive-access.png" alt="" /></div>
                            <div class="placement-assistance-right">
                                <h2>Exclusive access to Logicmojo Job portal</h2>
                                <p>Placement opportunities are provided once the learner is moved to the placement pool. Get noticed by our 400+ hiring partners.</p>
                                <a href="#"><i class="fa fa-calendar-o" aria-hidden="true"></i> After 80% of the course completion</a>
                            </div>
                        </div>
                    </div>
                    <div id="tab021" class="tab-pane">
                        <div class="placement-assistance">
                            <div class="placement-assistance-left"><img src="assets/images/exclusive-access.png" alt="" /></div>
                            <div class="placement-assistance-right">
                                <h2>Exclusive access to Logicmojo Job portal</h2>
                                <p>Placement opportunities are provided once the learner is moved to the placement pool. Get noticed by our 400+ hiring partners.</p>
                                <a href="#"><i class="fa fa-calendar-o" aria-hidden="true"></i> After 100% of the course completion</a>
                            </div>
                        </div>
                        <div class="placement-assistance">
                            <div class="placement-assistance-left"><img src="assets/images/placement-assistance.png" alt="" /></div>
                            <div class="placement-assistance-right">
                                <h2>Placement Assistance</h2>
                                <p>Placement opportunities are provided once the learner is moved to the placement pool. Get noticed by our 400+ hiring partners.</p>
                                <a href="#"><i class="fa fa-calendar-o" aria-hidden="true"></i> After 80% of the course completion</a>
                            </div>
                        </div>
                    </div>
                    <div id="tab022" class="tab-pane">
                        <div class="placement-assistance">
                            <div class="placement-assistance-left"><img src="assets/images/placement-assistance.png" alt="" /></div>
                            <div class="placement-assistance-right">
                                <h2>Placement Assistance</h2>
                                <p>Placement opportunities are provided once the learner is moved to the placement pool. Get noticed by our 400+ hiring partners.</p>
                                <a href="#"><i class="fa fa-calendar-o" aria-hidden="true"></i> After 100% of the course completion</a>
                            </div>
                        </div>
                        <div class="placement-assistance">
                            <div class="placement-assistance-left"><img src="assets/images/exclusive-access.png" alt="" /></div>
                            <div class="placement-assistance-right">
                                <h2>Exclusive access to Logicmojo Job portal</h2>
                                <p>Placement opportunities are provided once the learner is moved to the placement pool. Get noticed by our 400+ hiring partners.</p>
                                <a href="#"><i class="fa fa-calendar-o" aria-hidden="true"></i> After 80% of the course completion</a>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</div>


<div class="network-reach-newbg">
    <div class="container">
        <h1>The Network Reach of Our Bay</h1>
        <div class="row">
            <div class="col-lg-5">
                <div class="keyfeaturenew">
                    <h2>Our Key Features</h2>
                    <ul>
                        <li>We help you build a strong profile and prepare for MNC interviews.</li>
                        <li>Hassle-free and tailored training for MAANG company interviews.</li>
                        <li>Even after a career break, securing a dream job is achievable.</li>
                        <li>A successful career transition even with 0 coding experience.</li>
                    </ul>
                    <a href="#" class="downreportbtn">Download Placement Report <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                </div>
            </div>
            <div class="col-lg-7">
                <div class="keyfeaturenew-logo">
                    <a href="#"><img src="assets/images/featurelogo1.png" alt="" /></a>
                    <a href="#"><img src="assets/images/featurelogo2.png" alt="" /></a>
                    <a href="#"><img src="assets/images/featurelogo3.png" alt="" /></a>
                    <a href="#"><img src="assets/images/featurelogo5.png" alt="" /></a>
                    <a href="#"><img src="assets/images/metalogo.png" alt="" /></a>
                    <a href="#"><img src="assets/images/walmarticon.png" alt="" /></a>
                    <a href="#"><img src="assets/images/googleicon.png" alt="" /></a>
                    <a href="#"><img src="assets/images/uber_logo.png" alt="" /></a>
                    <a href="#"><img src="assets/images/intuit_logo.png" alt="" /></a>
                    <a href="#"><img src="assets/images/intel-logo.png" alt="" /></a>
                    <a href="#"><img src="assets/images/ola-logo.png" alt="" /></a>
                    <a href="#"><img src="assets/images/ibm-logo.png" alt="" /></a>
                    <a href="#"><img src="assets/images/samsung-logo.png" alt="" /></a>
                    <a href="#"><img src="assets/images/paypal-logo.png" alt="" /></a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="certificate-companies">
    <div class="container">
        <div class="certificate-companies-img"><img src="assets/images/certificate-companies.png" alt="" /></div>
        <div class="certificate-companies-text">
            <h5>Certificate from companies</h5>
            <h1>Get Certificate directly from AI companies</h1>
            <p>Use Python 3.5 (64-bit) with OpenCV for face detection. The learners must ensure that the system will have to detect multiple faces in a single image. Students must work with essential libraries such as CV2 and Glob.</p>
            <a href="#">Download Brochure <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
        </div>
    </div>
</div>

<div class="howtoapply-new">
    <div class="container">
        <h1>How to Apply</h1>
        <div class="row">

            <div class="col-lg-8">
                <div class="howtoapply-new-left">
                    <ul>
                        <li>
                            <h4>Step 1</h4>
                            <h3>Submit Application</h3>
                            <p>Tell us a bit about yourself and why you want todo this program</p>
                        </li>
                        <li>
                            <h4>Step 2</h4>
                            <h3>Application Review</h3>
                            <p>An admission penel will shortlist candidates based on their application</p>
                        </li>
                        <li>
                            <h4>Step 3</h4>
                            <h3>Admission</h3>
                            <p>Selected candidates can begin the PGP AI MI, online within 1-2 weeks</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="howtoapply-new-right">
                    <h2>Apply Now</h2>
                    <div class="howtoapply-new-rightform">
                        <form>
        
                            <div class="row"> 
                            
                                  <div class="form-group col-lg-12">
                                    <input type="text" class="form-control" placeholder="Name" />
                                  </div>
    
                                  <div class="form-group col-lg-12">
                                    <input type="text" class="form-control" placeholder="Email address" />
                                  </div>
    
                                  <div class="form-group col-lg-12">
                                    <input type="text" class="form-control" placeholder="Phone number" />
                                  </div>
                      
                                  <div class="form-group col-lg-12">
                                    <select name="" id="" class="form-control">
                                        <option value="">Total work experience*</option>
                                    </select>
                                  </div>

                                  <div class="form-group col-lg-12 privacytext">
                                    By providing your contact details, you agree to our <a href="#">Privacy Policy</a>
                                  </div>
    
                                  <div class="form-group col-lg-12">
                                    <input type="submit" class="submitbtn" value="Submit"/>
                                  </div>
                      
                      
                                </div>
                            
                                </form>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<div class="programfeenew">
    <div class="container">
        <h1>Total Program Fee</h1>
        <div class="programfeenew-inner">
            <div class="programfeenew-inner-left">
                <div class="programfeenew-inner-price">
                    <p>Total Program Fee</p>
                    <h2>₹ 2,19,999</h2>
                </div>
            </div>
            <div class="programfeenew-inner-right">
                <h5>No Cost EMI</h5>
                <div class="d-flex align-items-center justify-content-between">
                    <h4><span>As low as</span> ₹ 7, 303/month</h4>
                    <a href="#">Apply now</a>
                </div>
                <p>We have partnered with the following financing companies to provide competitive finance options at 0% interest rate with no hidden costs...</p>
                <ul>
                    <li><img src="assets/images/feelogo1.png" alt="" /></li>
                    <li><img src="assets/images/feelogo2.png" alt="" /></li>
                    <li><img src="assets/images/feelogo3.png" alt="" /></li>
                    <li><img src="assets/images/feelogo4.png" alt="" /></li>
                    <li><img src="assets/images/feelogo5.png" alt="" /></li>
                </ul>
            </div>
        </div>
    </div>
</div>


<div class="eligibility-criteria-row">
    <div class="container">

        <div class="row">

        <div class="col-md-6">
            <div class="eligibility-criteria">
                <h2>Eligibility Criteria</h2>
                <ul class="eligibilitylist1">
                    <li><span><img src="assets/images/eligibilitylist1-icon1.png" alt="" /></span> A bechelor's degree with an average of 50% or higher marks</li>
                    <li><span><img src="assets/images/eligibilitylist1-icon2.png" alt="" /></span> Basic understanding of programming concepts and mathematics</li>
                    <li><span><img src="assets/images/eligibilitylist1-icon3.png" alt="" /></span> 2+ years of work experience preferred</li>
                </ul>
            </div>
        </div>

        <div class="col-md-6">
            <div class="eligibility-criteria">
                <h2>Best Suited For</h2>
                <ul class="eligibilitylist2">
                    <li>Software engineers</li>
                    <li>IT Professionals</li>
                    <li>Data Professionals</li>
                    <li>Business Analysis</li>
                    <li>Product Managers</li>
                 </ul>
            </div>
        </div>

    </div>
</div>
</div>



<div class="faqnewbg">
    <div class="container">
        <h1>FAQ,s</h1>
        <div class="faqnewbg-inner">
            
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" data-toggle="tab" href="#tab023">payments and scholarships</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#tab024">capstone and real-time projects</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#tab025">certification</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#tab026">job assistance</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#tab027">mentorships</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#tab028">support</a>
                </li>
             </ul>

             <div class="tab-content">

                <div id="tab023" class="tab-pane active">
                    <div class="faqnew">
                    <div class="accordion" id="accordionExample2">

                        <div class="card">
                        
                            <div class="card-header" id="heading00">
                        
                              <h2 class="mb-0">
                        
                                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse00" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse00" class="collapse" aria-labelledby="heading00" data-parent="#accordionExample2">
                        
                              <div class="card-body">
                        
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                        
                              </div>
                        
                            </div>
                        
                        </div>

                        <div class="card">
                        
                            <div class="card-header" id="heading01">
                        
                              <h2 class="mb-0">
                        
                                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse01" aria-expanded="false"><i class="fa fa-angle-down"></i> What if I miss a few classes due to an emergency? </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse01" class="collapse" aria-labelledby="heading01" data-parent="#accordionExample2">
                        
                              <div class="card-body">
                        
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                        
                              </div>
                        
                            </div>
                        
                        </div>

                        <div class="card">
                        
                            <div class="card-header" id="heading02">
                        
                              <h2 class="mb-0">
                        
                                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse02" aria-expanded="false"><i class="fa fa-angle-down"></i> What is a Flexi Subscription in Data Science Foundation Program? </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse02" class="collapse" aria-labelledby="heading02" data-parent="#accordionExample2">
                        
                              <div class="card-body">
                        
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                        
                              </div>
                        
                            </div>
                        
                        </div>


                        <div class="card">
                        
                            <div class="card-header" id="heading03">
                        
                              <h2 class="mb-0">
                        
                                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse03" aria-expanded="false"><i class="fa fa-angle-down"></i> What’s the duration of the Data Science Foundation Program? </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse03" class="collapse" aria-labelledby="heading03" data-parent="#accordionExample2">
                        
                              <div class="card-body">
                        
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                        
                              </div>
                        
                            </div>
                        
                        </div>


                        <div class="card">
                        
                            <div class="card-header" id="heading04">
                        
                              <h2 class="mb-0">
                        
                                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse04" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse04" class="collapse" aria-labelledby="heading04" data-parent="#accordionExample2">
                        
                              <div class="card-body">
                        
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                        
                              </div>
                        
                            </div>
                        
                        </div>


                        <div class="card">
                        
                            <div class="card-header" id="heading05">
                        
                              <h2 class="mb-0">
                        
                                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse05" aria-expanded="false"><i class="fa fa-angle-down"></i> How can I opt for a Hybird mode of learning? </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse05" class="collapse" aria-labelledby="heading05" data-parent="#accordionExample2">
                        
                              <div class="card-body">
                        
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                        
                              </div>
                        
                            </div>
                        
                        </div>


                        <div class="card">
                        
                            <div class="card-header" id="heading06">
                        
                              <h2 class="mb-0">
                        
                                <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse06" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse06" class="collapse" aria-labelledby="heading06" data-parent="#accordionExample2">
                        
                              <div class="card-body">
                        
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                        
                              </div>
                        
                            </div>
                        
                        </div>

                        
                        </div>
                    </div>
                </div>

                <div id="tab024" class="tab-pane">
                    <div class="faqnew">
                        <div class="accordion" id="accordionExample2">
    
                            <div class="card">
                            
                                <div class="card-header" id="heading00">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse00" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse00" class="collapse" aria-labelledby="heading00" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            <div class="card">
                            
                                <div class="card-header" id="heading01">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse01" aria-expanded="false"><i class="fa fa-angle-down"></i> What if I miss a few classes due to an emergency? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse01" class="collapse" aria-labelledby="heading01" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            <div class="card">
                            
                                <div class="card-header" id="heading02">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse02" aria-expanded="false"><i class="fa fa-angle-down"></i> What is a Flexi Subscription in Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse02" class="collapse" aria-labelledby="heading02" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading03">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse03" aria-expanded="false"><i class="fa fa-angle-down"></i> What’s the duration of the Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse03" class="collapse" aria-labelledby="heading03" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading04">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse04" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse04" class="collapse" aria-labelledby="heading04" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
    
                            
                            </div>
                        </div>
                </div>

                <div id="tab025" class="tab-pane">
                    
                    <div class="faqnew">
                        <div class="accordion" id="accordionExample2">
    
                            <div class="card">
                            
                                <div class="card-header" id="heading00">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse00" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse00" class="collapse" aria-labelledby="heading00" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            <div class="card">
                            
                                <div class="card-header" id="heading01">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse01" aria-expanded="false"><i class="fa fa-angle-down"></i> What if I miss a few classes due to an emergency? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse01" class="collapse" aria-labelledby="heading01" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            <div class="card">
                            
                                <div class="card-header" id="heading02">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse02" aria-expanded="false"><i class="fa fa-angle-down"></i> What is a Flexi Subscription in Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse02" class="collapse" aria-labelledby="heading02" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading03">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse03" aria-expanded="false"><i class="fa fa-angle-down"></i> What’s the duration of the Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse03" class="collapse" aria-labelledby="heading03" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading04">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse04" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse04" class="collapse" aria-labelledby="heading04" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading05">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse05" aria-expanded="false"><i class="fa fa-angle-down"></i> How can I opt for a Hybird mode of learning? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse05" class="collapse" aria-labelledby="heading05" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading06">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse06" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse06" class="collapse" aria-labelledby="heading06" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            
                            </div>
                        </div>

                </div>

                <div id="tab026" class="tab-pane">
                    
                    <div class="faqnew">
                        <div class="accordion" id="accordionExample2">
    
                            <div class="card">
                            
                                <div class="card-header" id="heading00">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse00" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse00" class="collapse" aria-labelledby="heading00" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            <div class="card">
                            
                                <div class="card-header" id="heading01">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse01" aria-expanded="false"><i class="fa fa-angle-down"></i> What if I miss a few classes due to an emergency? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse01" class="collapse" aria-labelledby="heading01" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            <div class="card">
                            
                                <div class="card-header" id="heading02">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse02" aria-expanded="false"><i class="fa fa-angle-down"></i> What is a Flexi Subscription in Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse02" class="collapse" aria-labelledby="heading02" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading03">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse03" aria-expanded="false"><i class="fa fa-angle-down"></i> What’s the duration of the Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse03" class="collapse" aria-labelledby="heading03" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading04">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse04" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse04" class="collapse" aria-labelledby="heading04" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading05">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse05" aria-expanded="false"><i class="fa fa-angle-down"></i> How can I opt for a Hybird mode of learning? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse05" class="collapse" aria-labelledby="heading05" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
    
                            
                            </div>
                        </div>

                </div>

                <div id="tab027" class="tab-pane">
                    
                    <div class="faqnew">
                        <div class="accordion" id="accordionExample2">
    
                            <div class="card">
                            
                                <div class="card-header" id="heading00">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse00" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse00" class="collapse" aria-labelledby="heading00" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            <div class="card">
                            
                                <div class="card-header" id="heading01">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse01" aria-expanded="false"><i class="fa fa-angle-down"></i> What if I miss a few classes due to an emergency? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse01" class="collapse" aria-labelledby="heading01" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            <div class="card">
                            
                                <div class="card-header" id="heading02">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse02" aria-expanded="false"><i class="fa fa-angle-down"></i> What is a Flexi Subscription in Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse02" class="collapse" aria-labelledby="heading02" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading03">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse03" aria-expanded="false"><i class="fa fa-angle-down"></i> What’s the duration of the Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse03" class="collapse" aria-labelledby="heading03" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading04">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse04" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse04" class="collapse" aria-labelledby="heading04" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading05">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse05" aria-expanded="false"><i class="fa fa-angle-down"></i> How can I opt for a Hybird mode of learning? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse05" class="collapse" aria-labelledby="heading05" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading06">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse06" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse06" class="collapse" aria-labelledby="heading06" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            
                            </div>
                        </div>

                </div>

                <div id="tab028" class="tab-pane">
                    
                    <div class="faqnew">
                        <div class="accordion" id="accordionExample2">
    
                            <div class="card">
                            
                                <div class="card-header" id="heading00">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse00" aria-expanded="false"><i class="fa fa-angle-down"></i> What are the prerewuisites for tha Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse00" class="collapse" aria-labelledby="heading00" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            <div class="card">
                            
                                <div class="card-header" id="heading01">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse01" aria-expanded="false"><i class="fa fa-angle-down"></i> What if I miss a few classes due to an emergency? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse01" class="collapse" aria-labelledby="heading01" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            <div class="card">
                            
                                <div class="card-header" id="heading02">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse02" aria-expanded="false"><i class="fa fa-angle-down"></i> What is a Flexi Subscription in Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse02" class="collapse" aria-labelledby="heading02" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
    
                            <div class="card">
                            
                                <div class="card-header" id="heading03">
                            
                                  <h2 class="mb-0">
                            
                                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse03" aria-expanded="false"><i class="fa fa-angle-down"></i> What’s the duration of the Data Science Foundation Program? </button>
                            
                                  </h2>
                            
                                </div>
                            
                                <div id="collapse03" class="collapse" aria-labelledby="heading03" data-parent="#accordionExample2">
                            
                                  <div class="card-body">
                            
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis facilis officia ut ipsam sit dolores, libero sapiente quam. Magni molestias quidem illo ipsum minus libero sapiente quam. Magni molestias quide tenetur quam minima dignissimos fugit? Iure?</p>
                            
                                  </div>
                            
                                </div>
                            
                            </div>
    
                            
                            </div>
                        </div>

                </div>

             </div>

        </div>
    </div>
</div>



<div class="supportbgnew">
    <div class="container">
        <h1>24/7 Learner’s Support</h1>
        <div class="supportbgnew-inner">
            <div class="supportbgnew-inner-img"><img src="assets/images/supportimg.png" alt="" /></div>
            <div class="supportbgnew-inner-content">
                <h4>Got more questions?</h4>
                <h2>Talk to our team directly</h2>
                <p>Reach us and a learning consultant will get in touch with you shortly</p>
                <a href="#"><i class="fa fa-whatsapp"></i> Enquire now</a>
                <a href="#"style={{background: '#1a64c0'}}><i class="fa fa-whatsapp"></i> +91 80889-75867</a>
            </div>
        </div>
    </div>
</div>


        </div>
        );
    }
}

export default Home;